import { useState, useMemo } from "react";

const CODE_BTN_STATUS = {
  INIT: "INIT",
  RESNED: "RESEND",
  COUNDDOWN: "COUNTDOWN",
};

const ADD_STEP = {
  CREATE: "CREATE",
  VERIFY: "VERIFY",
};
export const useHooks = () => {
  const [emailInput, setEmailInput] = useState("");
  const [pwdInput, setPwdInput] = useState("");
  const [rePwdInput, setRePwdInput] = useState("");
  const [currStep, setCurrStep] = useState(ADD_STEP.CREATE);
  const [emailBtnStatus, setEmailBtnStatus] = useState(CODE_BTN_STATUS.INIT);
  const [phoneBtnStatus, setPhoneBtnStatus] = useState(CODE_BTN_STATUS.INIT);

  const emailBtnDisabled = useMemo(() => {
    if (emailBtnStatus === CODE_BTN_STATUS.COUNDDOWN) {
      return true;
    }
    return false;
  }, [emailBtnStatus]);

  const phoneBtnDisabled = useMemo(() => {
    if (phoneBtnStatus === CODE_BTN_STATUS.COUNDDOWN) {
      return true;
    }
    return false;
  }, [phoneBtnStatus]);

  return {
    emailInput,
    setEmailInput,
    pwdInput,
    setPwdInput,
    rePwdInput,
    setRePwdInput,
    emailBtnStatus,
    phoneBtnStatus,
    setEmailBtnStatus,
    setPhoneBtnStatus,
    CODE_BTN_STATUS,
    emailBtnDisabled,
    phoneBtnDisabled,
    ADD_STEP,
    currStep,
    setCurrStep,
  };
};
